// extracted by mini-css-extract-plugin
module.exports = {"sociometryClassInfo":"SociometryClassInfo_sociometryClassInfo__1ylOw","label":"SociometryClassInfo_label__4RMZd","value":"SociometryClassInfo_value__MNKuL"};